import AssignPercentagesError from './AssignPercentagesError';
class InvalidBeneficiaryId extends AssignPercentagesError {
    constructor(options) {
        super('The beneficiary ID must be a valid UUID', options);
    }
}
export default InvalidBeneficiaryId;
